import { cn } from "@/lib/utils";

const REFLECTION_OPTIONS = [
  "Me sentí más ligero",
  "Tuve hinchazón",
  "Mucha hambre hoy",
  "Tuve buena energía",
  "Me costó seguir la rutina",
  "Mejor que ayer"
];

interface QuickReflectionChipsProps {
  selected: string[];
  onChange: (reflections: string[]) => void;
}

export const QuickReflectionChips = ({ selected, onChange }: QuickReflectionChipsProps) => {
  const toggleReflection = (reflection: string) => {
    if (selected.includes(reflection)) {
      onChange(selected.filter((r) => r !== reflection));
    } else {
      onChange([...selected, reflection]);
    }
  };

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-medium text-muted-foreground">Reflexiones rápidas (opcional)</h3>
      <div className="flex flex-wrap gap-2">
        {REFLECTION_OPTIONS.map((opt) => {
          const isSelected = selected.includes(opt);
          return (
            <button
              key={opt}
              onClick={() => toggleReflection(opt)}
              className={cn(
                "px-3 py-1.5 rounded-full text-xs transition-all border font-medium",
                isSelected 
                  ? "border-wellness-peach bg-wellness-peach text-white shadow-sm" 
                  : "border-border bg-secondary text-muted-foreground hover:border-wellness-peach/50 hover:bg-wellness-peach/5 hover:text-foreground"
              )}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
};
